import axios from 'axios';
import { forceLogoutOnUnauthorized } from './forceLogout';

const instance = axios.create({
  baseURL: window.API_URL,
  withCredentials: true
});

// Endpoints that legitimately return 401 for an unauthenticated visitor.
// Skipping them avoids a logout/redirect loop on a failed login attempt.
const UNAUTHENTICATED_PATHS = ['/api/signin', '/api/logout'];

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';

    const isUnauthorizedStatus = status === 401;
    const isNotSignInReq = !UNAUTHENTICATED_PATHS.some((path) => url.includes(path));

    if (isUnauthorizedStatus && isNotSignInReq) {
      forceLogoutOnUnauthorized();
    }

    return Promise.reject(error);
  }
);

export default instance;
